// extracted by mini-css-extract-plugin
export var announcementBar = "styles-module--announcement-bar--2e0fe";
export var announcementBarButton = "styles-module--announcement-bar-button--75020";
export var announcementBar__desktopContent = "styles-module--announcement-bar__desktop-content--6e69a";
export var announcementBar__mobileContent = "styles-module--announcement-bar__mobile-content--219bd";